<template>
  <div class="history-container">
    <!-- 顶部操作栏 -->
    <div class="content-header">
      <div class="header-left">
        <button class="back-btn" @click="handleBack">
          <img :src="cdnUrl + 'ai-left-icon.svg'" alt="返回" />
        </button>
        <span class="content-title">历史对话</span>
      </div>
      <div class="content-actions">
        <el-tooltip content="新建对话" placement="top">
          <img
            class="action-btn"
            @click="handleEdit"
            :src="cdnUrl + 'ai-add.svg'"
            alt=""
          />
        </el-tooltip>
        <el-tooltip content="展开" placement="top">
          <img
            class="action-btn"
            @click="toggleExpand"
            :src="cdnUrl + 'ai-full.svg'"
            alt=""
          />
        </el-tooltip>
        <img
          class="action-btn"
          @click="handleClose"
          :src="cdnUrl + 'ai-closed.svg'"
          alt=""
        />
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="history-content-wrapper">
      <!-- 左侧历史对话列表 -->
      <div class="history-sidebar" @scroll="handleSidebarScroll">
        <div
          v-for="item in historyList"
          :key="item.id"
          class="history-item"
          :class="{
            active: selectedId === item.id,
            hover: hoveredItem === item.id,
          }"
          @click="selectHistory(item)"
          @mouseenter="hoveredItem = item.id"
          @mouseleave="hoveredItem = null"
        >
          <div class="history-item-left">
            <img
              class="history-icon"
              :src="cdnUrl + 'ai-question.svg'"
              alt=""
            />
            <span class="history-title">{{ item.title }}</span>
            <div class="history-item-actions">
              <el-popover
                placement="bottom-start"
                width="80"
                trigger="click"
                :visible-arrow="false"
                popper-class="history-delete-popover"
              >
                <button class="delete-btn" @click="handleDelete(item.id)">
                  <img :src="cdnUrl + 'ai-delete.svg'" alt="删除" />
                  <span>删除</span>
                </button>
                <i slot="reference" class="el-icon-more more-icon"></i>
              </el-popover>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧对话内容 -->
      <div class="history-content">
        <!-- 对话消息区域 -->
        <div class="message-area global-ai-content" ref="messageArea">
          <!-- 示例消息 -->
          <div
            v-if="selectedId"
            class="message-list chat_window"
            ref="chat_window"
            @scroll="handleMessageScroll"
          >
            <div
              class="item"
              :class="item.messageType == 'answer' ? 'left' : 'right'"
              v-for="(item, index) in messageLists"
              :key="index"
            >
              <div
                class="message"
                :class="item.messageType == 'answer' ? 'AI' : 'monkey'"
              >
                <loading v-if="item.status == 'loading'"></loading>
                <span v-if="item.messageType == 'question'">{{
                  item.content
                }}</span>
                <template v-else-if="item.messageType == 'answer'">
                  <thank-box
                    v-if="item.thought && item.scenarioType != 3"
                    :loading="item.thankLoading"
                    :key="item.id"
                  >
                    <div v-html="compileMarkdown(item.thought)"></div>
                  </thank-box>
                  <thank-box
                    v-if="
                      item.thoughtArr &&
                      item.thoughtArr.length &&
                      item.scenarioType == 4
                    "
                    :loading="item.thankLoading"
                    :key="item.id"
                    :isAi="true"
                    :thoughtArr="item.thoughtArr"
                  >
                  </thank-box>
                  <template
                    v-if="
                      item.content &&
                      ![3].includes(item.scenarioType) &&
                      item.style != 'card'
                    "
                  >
                    <div
                      v-for="(block, idx) in renderedBlocks(item.content)"
                      :key="idx"
                    >
                      <!-- 普通 markdown 文本 -->
                      <div
                        v-if="block.type === 'markdown'"
                        class="md-content"
                        v-html="block.html"
                      ></div>
                      <!-- 表格块：按钮 + 表格 -->
                      <div
                        v-else-if="block.type === 'table'"
                        class="table-block"
                      >
                        <md-table>
                          <div v-html="block.html"></div>
                        </md-table>
                      </div>
                    </div>
                  </template>
                  <bi-table
                    v-if="item.scenarioType == 3 && item.content"
                    :data="JSON.parse(item.content)"
                  ></bi-table>
                  <ai-card
                    v-if="
                      item.scenarioType == 4 &&
                      item.style == 'card' &&
                      item.content
                    "
                    :cardInfo="JSON.parse(item.content)"
                    @cardClick="cardClick"
                  ></ai-card>
                </template>
                <handle
                  v-if="
                    item.messageType == 'answer' &&
                    item.status == 'completed' &&
                    (item.id || item.hasReChoose)
                  "
                  :item="item"
                  :copyText="item.content"
                  :isLike="item.likeStatus"
                  :isUnlike="item.dislikeStatus"
                  :hideCopy="item.style == 'card'"
                  :hasReChoose="item.hasReChoose"
                  @regenerate="handleRegenerate(item)"
                  @reChoose="reChoose"
                />
              </div>
            </div>
          </div>

          <!-- 未选择状态 -->
          <!-- <div v-else class="empty-state">
            <span>请选择一条历史对话查看</span>
          </div> -->
        </div>

        <!-- 功能标签 -->
        <div class="feature-tags-section">
          <div class="feature-tags">
            <button
              v-for="(tag, index) in featureTags"
              :key="index"
              class="feature-tag"
              :class="{ active: selectedTag === tag.type }"
              @click="selectFeature(tag.type)"
            >
              <img
                class="tag-icon"
                :src="cdnUrl + tag.active"
                alt=""
                v-if="selectedTag === tag.type"
              />
              <img class="tag-icon" :src="cdnUrl + tag.icon" alt="" v-else />
              <span>{{ tag.name }}</span>
            </button>
          </div>

          <!-- 更多下拉菜单 -->
          <div v-if="showMoreMenu" class="more-menu">
            <button
              v-for="(item, index) in moreMenuItems"
              :key="index"
              :class="[
                'more-menu-item',
                { 'more-menu-item__active': selectedTag === item.name },
              ]"
              @click="selectMoreItem(item.name)"
            >
              <img class="tag-icon" :src="cdnUrl + item.icon" alt="" />
              <span>{{ item.name }}</span>
            </button>
          </div>
        </div>

        <!-- 底部输入框 -->
        <div class="ai-tools-footer">
          <div :class="['input-wrapper', { 'input-wrapper__hover': hasInput }]">
            <el-input
              ref="inputRef"
              type="textarea"
              class="ai-textarea"
              :autosize="{ minRows: 1, maxRows: 5 }"
              placeholder="输入你想问我的问题..."
              v-model="inputText"
              @keydown.enter.native.prevent="handleSubmit"
            />
            <div class="btn-wrapper">
              <img
                class="submit-btn submit-btn_disabled"
                v-if="!hasInput || isMessage"
                :src="cdnUrl + 'ai-send-disabled.svg'"
                alt=""
              />
              <img
                @click="handleSubmit"
                class="submit-btn"
                v-else
                :src="cdnUrl + 'ai-send.svg'"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- BI表格选择组件 -->
    <select-bi-table
      v-if="showSelect"
      v-model="showSelect"
      :msgId="msgId"
      :conversationId="selectedId"
      :hasReChoose="hasReChoose"
      @confirm="handleConfirm"
      @close="handleBiTableClose"
    />
    <!-- 表格选择组件 -->
    <select-activity-table
      v-if="showSmsSelect"
      v-model="showSmsSelect"
      :type="selectType"
      :msgId="msgId"
      :conversationId="selectedId"
      :hasReChoose="hasReChoose"
      @confirm="handleSmsConfirm"
      @close="handleSmsTableClose"
    ></select-activity-table>
    <!-- 报告 -->
    <aiReportDialog
      v-if="showReport"
      :cardInfo="cardInfo"
      :visible.sync="showReport"
      platformCode="TB"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getConversationPage,
  deleteConversation,
  getMessagesPage,
  recognizeIntent,
  queryData,
} from "@/api/ai/newAi.js";
import { marked } from "marked";
import loading from "./loading.vue";
import handle from "./handle.vue";
import thankBox from "./thankBox.vue";
import biTable from "./biTable.vue";
import mdTable from "@/components/ai/components/mdTable.vue";
import aiCard from "@/components/ai/components/aiCard.vue";
import SelectBiTable from "@/components/ai/components/selectBiTable.vue";
import SelectActivityTable from "@/components/ai/components/selectActivityTable.vue";
import aiReportDialog from "@/components/ai/components/aiReportDialog.vue";
import { getSellerTBCategory } from "@/api/public";
import { fetchEventSource } from "@microsoft/fetch-event-source";
export default {
  name: "History",
  components: {
    loading,
    handle,
    biTable,
    thankBox,
    mdTable,
    aiCard,
    SelectBiTable,
    SelectActivityTable,
    aiReportDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedId: null,
      hoveredItem: null,
      selectedTag: null,
      inputText: "",
      currentPage: 1,
      pageSize: 40,
      isLoading: false,
      hasMore: true,
      currentHistory: {
        id: 1,
        title: "帮我出一份618不同...",
        question: "帮我出一份618不同阶段的短信营销策略",
        followUp:
          "这是一句长文案，这是一句长文案这是一句长文案这是一句长文案，自动换行。",
      },
      historyList: [],
      cdnUrl: "https://cdn-image.yucrm.cn/images/tb-front-platform/images/ai/",
      messageLists: [],
      isMessage: false,
      messagenew: "",
      thought: "",
      thoughtArr: [],
      cardStyle: "",
      dataLists: [],
      messagePage: 1,
      messagePageSize: 20,
      messageHasMore: true,
      messageLoading: false,
      featureTags: [
        {
          type: 1,
          name: "智能助手",
          icon: "ai-znzs.svg",
          active: "ai-znzs-active.svg",
        },
        // { name: "店铺诊断", icon: "ai-dpzd.svg", active: "ai-dpzd-active.svg" },
        {
          type: 2,
          name: "营销策略",
          icon: "ai-yxcl.svg",
          active: "ai-yxcl-active.svg",
        },
        {
          type: 3,
          name: "AgentBI",
          icon: "ai-fx.svg",
          active: "ai-fx-active.svg",
        },
        {
          type: 4,
          name: "AI分析",
          icon: "ai-fx.svg",
          active: "ai-fx-active.svg",
        },
      ],
      showMoreMenu: false,
      moreMenuItems: [
        { name: "AgentBI", icon: "ai-fx.svg", active: "ai-fx-active.svg" },
        { name: "AI分析", icon: "ai-fx.svg", active: "ai-fx-active.svg" },
        { name: "文案生成", icon: "ai-wasc.svg", active: "ai-wasc-active.svg" },
      ],
      autoScrollEnabled: true,
      isFirstMessage: true,
      sellerTBCategory: "",
      reqId: "",
      showSelect: false,
      showSmsSelect: false,
      selectType: "",
      cardInfo: {},
      showReport: false,
      msgId: "",
      hasReChoose: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener("click", this.handleDocumentClick);
    });
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleDocumentClick);
  },
  computed: {
    ...mapGetters(["softwareInfo", "sellerId"]),
    hasInput() {
      return this.inputText && this.inputText.trim().length > 0;
    },
    renderedBlocks() {
      return (text) => {
        return this.$parseMarkdownToBlocks(text);
      };
    },
  },
  watch: {
    messageLists(val) {
      if (val && val.length) {
        this.$nextTick(() => {
          if (this.$refs.chat_window) {
            const links = this.$refs.chat_window.querySelectorAll("a");
            links.forEach((link) => {
              link.setAttribute("target", "_blank");
              // 建议同时添加 rel 属性以增强安全性
              link.setAttribute("rel", "noopener noreferrer");
            });
          }
        });
      }
    },
  },
  created() {
    this.getList();
    // 获取卖家淘宝分类
    getSellerTBCategory().then((res) => {
      if (res.code == 200) {
        this.sellerTBCategory = res.data.category;
      }
    });
  },
  methods: {
    getList(isLoadMore = false) {
      if (this.isLoading) return;

      const page = isLoadMore ? this.currentPage + 1 : 1;
      getConversationPage({
        platform: "TB",
        userId: this.softwareInfo.platformAccountInfo.platformCompanyUserId,
        current: page,
        size: this.pageSize,
      })
        .then((res) => {
          if (isLoadMore) {
            this.historyList = [...this.historyList, ...res.data.records];
          } else {
            this.historyList = res.data.records;
            this.currentPage = 1;
            if (res.data.records && res.data.records.length > 0) {
              this.isFirstMessage = true;
              this.currentHistory = res.data.records[0];
              this.selectedId = res.data.records[0].id;
              this.setDetail(res.data.records[0].id);
            } else {
              this.selectedId = null;
              this.messageLists = [];
            }
          }

          this.hasMore = res.data.records.length >= this.pageSize;
          this.currentPage = page;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    setDetail(id, isLoadMore = false) {
      const page = isLoadMore ? this.messagePage + 1 : 1;
      getMessagesPage({
        conversationId: id,
        current: page,
        size: this.messagePageSize,
      }).then((res) => {
        if (isLoadMore) {
          this.messageLists = [
            ...res.data.records.reverse(),
            ...this.messageLists,
          ];
        } else {
          this.messageLists = res.data.records.reverse();
        }

        this.messageHasMore = res.data.records.length >= this.messagePageSize;
        this.messagePage = page;
        this.messageLoading = false;

        if (res.data.records && res.data.records.length) {
          this.selectedTag =
            res.data.records[res.data.records.length - 1].scenarioType;
          if (this.isFirstMessage) {
            this.scrollWindow();
            this.isFirstMessage = false;
          }
        }
      });
    },
    // 滚动到顶部加载更多
    handleMessageScroll(e) {
      const target = e.target;
      if (
        target.scrollTop <= 10 &&
        this.messageHasMore &&
        !this.messageLoading &&
        this.selectedId
      ) {
        this.messageLoading = true;
        this.setDetail(this.selectedId, true);
      }
      const { scrollTop, clientHeight, scrollHeight } = this.$refs.chat_window;
      this.autoScrollEnabled = scrollTop + clientHeight >= scrollHeight;
    },
    // 滚动到底部加载更多
    handleSidebarScroll(e) {
      const target = e.target;
      if (
        target.scrollTop + target.clientHeight >= target.scrollHeight - 10 &&
        this.hasMore &&
        !this.isLoading
      ) {
        this.getList(true);
      }
    },
    handleDocumentClick(event) {
      const moreMenu = this.$el.querySelector(".more-menu");
      const featureTags = this.$el.querySelectorAll(".feature-tag");
      let moreBtn = null;
      for (let i = 0; i < featureTags.length; i++) {
        if (featureTags[i].textContent.includes("更多")) {
          moreBtn = featureTags[i];
          break;
        }
      }
      if (
        moreMenu &&
        !moreMenu.contains(event.target) &&
        moreBtn &&
        !moreBtn.contains(event.target)
      ) {
        this.showMoreMenu = false;
      }
    },
    selectHistory(item) {
      this.selectedId = item.id;
      this.currentHistory = item;
      this.messagePage = 1;
      this.messageHasMore = true;
      this.isFirstMessage = true;
      this.setDetail(item.id);
    },
    selectFeature(type) {
      this.selectedTag = this.selectedTag === type ? "" : type;
    },
    selectMoreItem(name) {
      this.selectedTag = name;
      this.showMoreMenu = false;
    },
    handleBack() {
      this.$emit("back");
    },
    handleEdit() {
      this.$emit("edit");
    },
    toggleExpand() {
      this.$emit("toggleExpand", this.selectedId, "history");
    },
    handleClose() {
      this.$emit("close");
    },
    // 获取数据报表
    getReportMessage(message, scenarioType, dataList) {
      if (this.controller) {
        this.controller.abort();
        this.controller = null;
      }
      this.appendMessage({
        messageType: "question",
        content: message,
        status: "completed",
      });
      this.appendMessage({
        messageType: "answer",
        scenarioType: scenarioType ? scenarioType : this.selectedTag,
        thought: "",
        content: "",
        thankLoading: false,
        status: "loading",
      });
      this.isMessage = true;
      this.controller = new AbortController();
      const obj = {
        platform: "TB",
        scenarioType: scenarioType ? scenarioType : this.selectedTag,
        userId: this.softwareInfo.platformAccountInfo.platformCompanyUserId,
        sellerId: this.sellerId || "",
        conversationId: this.selectedId,
        message: message,
        reqId: this.selectedId,
        companyId:
          this.softwareInfo.platformAccountInfo.platformCompanyInfoId || "",
      };
      if (obj.scenarioType == 1 || obj.scenarioType == 2) {
        obj.category = this.sellerTBCategory;
      }
      let _this = this;
      let fn = "/yunqi-ai-api/ai/dataReport/report";
      if (obj.scenarioType == 2) {
        fn = "/yunqi-ai-api/marketing-strategy/stream";
      } else if (obj.scenarioType == 1) {
        fn = "/yunqi-ai-api/ai/sendMessage";
      } else if (obj.scenarioType == 4) {
        fn = "/yunqi-ai-api/ai-analysis/stream";
      }
      if (dataList) {
        fn = "/yunqi-ai-api/ai-analysis/report/stream";
        if (this.selectType == "sence") {
          obj.scenarioSubType = 2;
          obj.biReportCodeList = dataList;
        } else if (this.selectType == "message") {
          obj.scenarioSubType = 3;
          obj.smsBatchList = dataList;
        } else if (this.selectType == "hd") {
          obj.scenarioSubType = 4;
          obj.activityList = dataList;
        }
      }
      this.thought = "";
      this.messagenew = "";
      this.thoughtArr = [];
      this.cardStyle = "";
      this.inputText = "";
      this.reqId = "";
      this.msgId = "";
      this.$nextTick(() => {
        this.scrollWindow();
      });
      fetchEventSource(fn, {
        signal: this.controller.signal,
        openWhenHidden: true,
        method: "POST",
        headers: {
          Accept: "text/event-stream",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(obj),
        onopen(response) {
          if (response.ok) {
            console.log("SSE连接成功", response);
          } else {
            throw new Error(`SSE连接失败: `, response);
          }
        },
        onmessage(event) {
          //服务返回的数据
          console.log("res数据", event);
          let id = "";
          let thankLoading = true;
          let content = null;
          if (event.event == "thought") {
            try {
              let newdata = JSON.parse(event.data);
              _this.thought = _this.thought + newdata.msg;
            } catch (err) {}
          } else if (event.event == "message") {
            try {
              let newdata = JSON.parse(event.data);
              if (!_this.reqId) {
                _this.messagenew = _this.messagenew + newdata.msg;
              }
            } catch (err) {
              _this.messagenew = event.data;
            }
            if (_this.messagenew) {
              thankLoading = false;
            }
          } else if (event.event == "reqId") {
            _this.reqId = event.data;
          } else if (event.event == "done") {
            try {
              const newdata = JSON.parse(event.data);
              id = newdata.id;
            } catch (err) {}
          } else if (event.event == "task") {
            try {
              let newdata = JSON.parse(event.data);
              // 如果是 completed 状态，查找并替换对应的 running 状态的 task
              if (
                newdata.status === "completed" ||
                newdata.status === "failed"
              ){
                // 提取 task 的标识信息（从 msg 中提取报表名称）
                // 例如：从 "开始提取「全店销售分析」报表数据..." 中提取 "全店销售分析"
                const matchRunning = newdata.msg.match(/「([^」]+)」/);
                if (matchRunning) {
                  const taskName = matchRunning[1];
                  // 查找数组中是否有包含相同名称的 running 状态的 task
                  const index = _this.thoughtArr.findIndex((item) => {
                    if (item.status !== "running") return false;
                    const itemMatch = item.msg.match(/「([^」]+)」/);
                    return itemMatch && itemMatch[1] === taskName;
                  });
                  if (index !== -1) {
                    // 找到匹配项，替换它
                    _this.$set(_this.thoughtArr, index, newdata);
                  } else {
                    // 没找到匹配项，直接添加
                    _this.thoughtArr.push(newdata);
                  }
                } else {
                  // 无法提取名称，直接添加
                  _this.thoughtArr.push(newdata);
                }
              } else {
                // 不是 completed 状态，直接添加
                _this.thoughtArr.push(newdata);
              }
            } catch (err) {}
          } else if (event.event == "card") {
            thankLoading = false;
            try {
              _this.messagenew = event.data;
              _this.cardStyle = "card";
            } catch (err) {}
          } else if (event.event == "select-items-bi") {
            thankLoading = false;
            try {
              const newdata = JSON.parse(event.data);
              _this.showSelect = true;
              _this.selectType = "sence";
              _this.msgId = newdata.msg;
            } catch (err) {}
          } else if (event.event == "select-items-sms") {
            thankLoading = false;
            try {
              const newdata = JSON.parse(event.data);
              _this.showSmsSelect = true;
              _this.selectType = "message";
              _this.msgId = newdata.msg;
            } catch (err) {}
          } else if (event.event == "select-items-activity") {
            thankLoading = false;
            try {
              const newdata = JSON.parse(event.data);
              _this.showSmsSelect = true;
              _this.selectType = "hd";
              _this.msgId = newdata.msg;
            } catch (err) {}
          }
          let status =
            !_this.thought && !_this.messagenew && !_this.thoughtArr.length
              ? "loading"
              : "add";
          if (id) {
            status = "completed";
            thankLoading = false;
          }
          const scenarioType = scenarioType ? scenarioType : _this.selectedTag;
          if (!_this.reqId && scenarioType == 3) {
            status = "loading";
          }
          if ([1, 2, 4].includes(scenarioType)) {
            content = _this.messagenew;
          }
          if (!_this.msgId) {
            _this.appendMessage({
              messageType: "answer",
              scenarioType: scenarioType,
              thought: _this.thought,
              thoughtArr: _this.thoughtArr,
              content: content ? content : "",
              thankLoading,
              status: status,
              dislikeStatus: false,
              likeStatus: false,
              id: id,
              style: _this.cardStyle,
            });
          } else {
            let len = _this.messageLists.length;
            if (len) {
              let lastMessage = _this.messageLists[len - 1];
              if (lastMessage.status == "loading") {
                _this.messageLists.splice(len - 1, 1);
              }
            }
          }
          if (_this.autoScrollEnabled) {
            _this.$nextTick(() => {
              _this.scrollWindow();
            });
          }
        },
        onerror(err) {
          // 服务异常
          console.error("SSE错误:", err);
          _this.appendMessage({
            messageType: "answer",
            content: "当前请求较多，请稍后再试~",
            status: "completed",
          });
          _this.question = "";
          _this.isMessage = false;
          throw event;
        },
        onclose() {
          setTimeout(() => {
            _this.scrollWindow();
          }, 500);
          const scenarioType = scenarioType ? scenarioType : _this.selectedTag;
          if (scenarioType == 3) {
            _this.getReportData();
          } else {
            _this.isMessage = false;
          }
        },
      });
    },
    getReportData() {
      queryData({
        platform: "TB",
        reqId: this.reqId,
        userId: this.softwareInfo.platformAccountInfo.platformCompanyUserId,
        companyId:
          this.softwareInfo.platformAccountInfo.platformCompanyInfoId || "",
        sellerId: this.sellerId || "",
        conversationId: this.selectedId,
        scenarioType: 3,
      })
        .then((res) => {
          if (res.code == 200) {
            this.isMessage = false;
            // 更新messageLists最后一条数据，添加biData字段
            if (this.messageLists.length > 0) {
              const lastIndex = this.messageLists.length - 1;
              this.$set(
                this.messageLists[lastIndex],
                "content",
                JSON.stringify(res.data)
              );
              this.$set(
                this.messageLists[lastIndex],
                "id",
                JSON.stringify(res.data.id)
              );
              this.$set(this.messageLists[lastIndex], "status", "completed");
            }
          }
        })
        .catch(() => {
          this.isMessage = false;
        });
    },
    appendMessage(options) {
      const {
        messageType,
        content,
        status = "completed",
        thought,
        dislikeStatus,
        likeStatus,
        id,
        scenarioType,
        thankLoading,
        thoughtArr,
        style,
        hasReChoose,
      } = options;
      const message = {
        messageType,
        status: status,
        content,
        thought,
        dislikeStatus,
        likeStatus,
        id,
        scenarioType,
        thankLoading,
        thoughtArr,
        style,
        hasReChoose,
      };
      let len = this.messageLists.length;
      if (
        len &&
        ["loading", "add"].includes(this.messageLists[len - 1].status)
      ) {
        this.messageLists[len - 1] = message;
        this.$set(this.messageLists, len - 1, message);
      } else {
        this.messageLists.push(message);
      }
    },
    // 滚动AI聊天窗口
    scrollWindow() {
      this.$nextTick(() => {
        const objDiv = this.$refs.chat_window;
        if (!objDiv) return;

        const doScroll = () => {
          objDiv.scrollTop = objDiv.scrollHeight;
        };

        // 立即尝试一次滚动
        doScroll();

        // 查找所有图片并监听加载事件
        const images = objDiv.querySelectorAll("img");
        if (images.length === 0) return;

        let loadedCount = 0;
        const totalImages = images.length;

        const checkAllLoaded = () => {
          loadedCount++;
          if (loadedCount >= totalImages) {
            this.$nextTick(() => {
              doScroll();
            });
          }
        };

        images.forEach((img) => {
          if (img.complete) {
            // 图片已加载完成
            checkAllLoaded();
          } else {
            // 监听图片加载
            img.addEventListener("load", checkAllLoaded);
            img.addEventListener("error", checkAllLoaded); // 加载失败也触发
          }
        });
      });
    },
    compileMarkdown(content) {
      if (!content) return "";
      return marked(content);
    },
    deletedClick() {
      console.log("deletedClick");
    },
    handleSubmit() {
      if (this.isMessage) return;
      if (this.inputText) {
        if (this.selectedTag) {
          this.getReportMessage(this.inputText);
        } else {
          recognizeIntent({
            message: this.inputText,
          }).then((res) => {
            this.selectedTag = res.data.scenarioType;
            this.getReportMessage(this.inputText, res.data.scenarioType);
          });
        }
      }
    },
    // 删除
    handleDelete(id) {
      deleteConversation(id).then((res) => {
        if (res.code == 200) {
          this.getList();
          this.$emit("delete", id);
        }
      });
    },
    // 重新生成
    handleRegenerate(val) {
      const index = this.messageLists.findIndex((item) => item.id == val.id);
      const preIndex = index - 1;
      const preObj = this.messageLists[preIndex];
      if (preObj && preObj.messageType == "question") {
        this.selectedTag = val.scenarioType;
        this.getReportMessage(preObj.content, val.scenarioType);
      }
    },
    handleConfirm(values) {
      let str = "已选择报表：";
      const valueArr = [];
      const enumNames = [];
      values.forEach((item) => {
        valueArr.push(`【${item.name}】`);
        enumNames.push(item.enumName);
      });
      str = str + valueArr.join("、");
      this.getReportMessage(str, 4, enumNames);
    },
    handleSmsConfirm(values, type) {
      console.log("选中的报表：", values);
      let str = "";
      const selectType = type ? type : this.selectType;
      const valueArr = [];
      if (selectType == "hd") {
        str = "已选互动活动：";
        values.forEach((item) => {
          valueArr.push(`【${item.activityName}/${item.activityId}】`);
        });
      } else {
        str = "已选短信活动：";
        values.forEach((item) => {
          valueArr.push(`【${item.title}/${item.batchId}】`);
        });
      }
      str = str + valueArr.join("、");
      this.getReportMessage(str, 4, values);
    },
    handleBiTableClose() {
      this.hasReChoose = false;
      this.showSelect = false;
      this.appendMessage({
        messageType: "answer",
        content:
          "好的，你还可以试试：帮我做一下上个月的复盘、帮我帮我生成短信营销效果复盘、帮我分析上个月的满额有礼活动数据",
        thankLoading: false,
        status: "completed",
        hasReChoose: true,
      });
    },
    handleSmsTableClose() {
      this.hasReChoose = false;
      this.showSmsSelect = false;
      if (this.selectType == "hd") {
        this.appendMessage({
          messageType: "answer",
          content:
            "好的，你还可以试试：帮我做一下上个月的复盘、帮我分析一下商品复购数据、帮我帮我生成短信营销效果复盘",
          thankLoading: false,
          status: "completed",
          hasReChoose: true,
        });
      } else {
        this.appendMessage({
          messageType: "answer",
          content:
            "好的，你还可以试试：帮我做一下上个月的复盘、帮我分析一下商品复购数据、帮我分析上个月的满额有礼活动数据",
          thankLoading: false,
          status: "completed",
          hasReChoose: true,
        });
      }
    },
    cardClick(cardInfo) {
      this.cardInfo = cardInfo;
      this.showReport = true;
    },
    // 重新选择
    reChoose() {
      if (this.selectType == "sence") {
        this.showSelect = true;
      } else if (this.selectType == "message") {
        this.showSmsSelect = true;
      } else if (this.selectType == "hd") {
        this.showSmsSelect = true;
      }
      this.hasReChoose = true;
    },
  },
};
</script>

<style lang="scss">
.history-delete-popover {
  min-width: 120px;
  padding: 4px !important;
  border-radius: 8px !important;
}
</style>

<style lang="scss" scoped>
.history-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

/* 顶部操作栏 */
.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  color: #333;
  border-bottom: 1px solid #e9e9e9;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.back-btn {
  width: 28px;
  height: 28px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.back-btn img {
  width: 16px;
  height: 16px;
}

.content-title {
  font-size: 16px;
  font-weight: 500;
}

.content-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  cursor: pointer;
  width: 32px;
  height: 32px;
}

/* 内容区域 */
.history-content-wrapper {
  display: flex;
  flex: 1;
  overflow: hidden;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

/* 左侧历史列表 */
.history-sidebar {
  padding-top: 10px;
  width: 240px;
  min-width: 240px;
  background-color: #f8f9fa;
  border-right: 1px solid #e9e9e9;
  overflow-y: auto;
}

.history-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  cursor: pointer;
  border-radius: 8px;
  margin: 2px 10px;
  position: relative;
  outline: none;
}

.history-item:hover {
  background-color: #eeeef1;
}

.history-item.active {
  background-color: #fff;
  border: 1px solid #e9e9e9;
}

.history-item-left {
  display: flex;
  align-items: center;
  flex: 1;
  overflow: hidden;
}

.history-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  flex-shrink: 0;
}

.history-title {
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}

.history-item-actions {
  display: flex;
  align-items: center;
  margin-left: 8px;
}

.more-icon {
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #999;
  font-size: 16px;
  opacity: 0;
  transition: opacity 0.2s;
}

.history-item:hover .more-icon {
  opacity: 1;
}

.delete-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #f56c6c;
  font-weight: 500;
  transition: all 0.2s ease;
  padding: 8px 8px;

  &:hover {
    background-color: #f5f5f5;
  }
}

.delete-btn img {
  width: 20px;
  height: 20px;
}

/* 右侧内容区 */
.history-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  overflow: hidden;
}

.content-title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.content-actions {
  display: flex;
  gap: 12px;
}

.action-btn {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.action-btn img {
  width: 16px;
  height: 16px;
}

/* 消息区域 */
.message-area {
  flex: 1;
  overflow-y: auto;
  padding: 20px 0px 20px 20px;
  background-color: #fff;
}

.message-list {
  display: flex;
  flex-direction: column;
}

.user-message {
  display: flex;
  justify-content: flex-end;
}

.ai-message {
  display: flex;
  justify-content: flex-start;
}

.message-bubble {
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  max-width: 70%;
  word-break: break-all;
}

.user-bubble {
  background: #ecf4ff;
  color: #333;
  border-radius: 16px;
}

.user-bubble.long {
  max-width: 90%;
}

.ai-content {
  max-width: 90%;
}

.main-title {
  font-size: 20px;
  font-weight: bold;
  color: #303133;
  margin: 0 0 12px 0;
}

.sub-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
  margin: 16px 0 8px 0;
}

.content-text {
  font-size: 16px;
  color: #606266;
  line-height: 1.8;
  margin: 0;
  text-indent: 2em;
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #909399;
}

/* 对话列表样式 */
.chat_window {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-right: 20px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  .item {
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    &:last-child {
      margin-bottom: 20px;
    }

    img {
      width: 40px;
      height: 40px;
    }

    .message {
      position: relative;
      max-width: 450px;
      line-height: 20px;
      font-size: 14px;
      word-break: break-all;

      span {
        white-space: pre-wrap;
      }
    }

    .AI {
      color: #333333;
      padding: 0px;
      max-width: 100%;
      width: 100%;
    }

    .monkey {
      background: #ddeaff;
      border-radius: 16px;
      color: #333;
      padding: 12px 16px;
    }
  }

  .left {
    justify-content: start;
    padding-bottom: 50px;
    margin-bottom: 0px;

    &:hover {
      .message_handle {
        display: flex;
      }
    }
  }

  .right {
    justify-content: end;
  }
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  gap: 12px;
  padding: 12px 0;
  border-top: 1px dashed #e4e7ed;
}

.action-icon-btn {
  width: 36px;
  height: 36px;
  border: 1px solid #e4e7ed;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.action-icon-btn:hover {
  border-color: #409eff;
  background-color: #ecf5ff;
}

.action-icon-btn img {
  width: 16px;
  height: 16px;
}

.feature-tags-section {
  padding: 0px 20px;
  background: #fff;
  position: relative;
}

.feature-tags {
  display: flex;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
}

.feature-tag {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 7px 14px;
  background-color: #fff;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    background: #f4f4f4;
  }
}

.feature-tag.active {
  background: linear-gradient(330deg, #2986fe 0%, #d7abff 100%);
  color: #fff;
}

.tag-icon {
  width: 16px;
  height: 16px;
}

.tag-arrow {
  font-size: 10px;
  margin-left: 2px;
  transition: transform 0.2s;
}

.feature-tag.active .tag-arrow {
  transform: rotate(180deg);
}

.more-menu {
  position: absolute;
  margin-top: 8px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 2px;
  z-index: 100;
  width: 150px;
  top: -130px;
  right: 28px;
}

.more-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 16px;
  width: 120px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  border-radius: 4px;
  transition: background-color 0.2s;
  width: 100%;

  &__active {
    background-color: #f4f4f4;
  }
}

.more-menu-item:hover {
  background-color: #f4f4f4;
}

.more-menu-item img {
  width: 16px;
  height: 16px;
}

.ai-tools-footer {
  padding: 12px 20px;
  background-color: #fff;
}

.input-wrapper {
  position: relative;
  border-radius: 8px;
  border: 1px solid #f1f1f1;
  padding: 12px;
}

.input-wrapper__hover {
  border: 1px solid #3159ff;
}

.ai-textarea {
  width: 100%;
  font-size: 14px;
  padding-right: 12px;
}

.ai-textarea ::v-deep textarea {
  padding: 0px;
  resize: none;
  outline: none;
  &::placeholder {
    color: #bfbfbf;
    font-weight: 400;
  }
}

.ai-textarea ::v-deep textarea::-webkit-scrollbar {
  width: 4px;
  border-radius: 2px;
}

.ai-textarea ::v-deep textarea::-webkit-scrollbar-thumb {
  background-color: #d9d9d9;
}

.ai-textarea ::v-deep textarea::-webkit-scrollbar-track {
  background-color: #f3f3f3;
}

.ai-textarea ::v-deep .el-textarea__inner {
  border-color: #e4e7ed;
  border-radius: 8px !important;
  padding-right: 12px;
  border: none !important;
  color: #333;
}

.btn-wrapper {
  display: flex;
  justify-content: flex-end;
}

.submit-btn {
  width: 32px;
  height: 32px;
  cursor: pointer;
}

.submit-btn_disabled {
  cursor: not-allowed;
}

.submit-btn:hover:not(.submit-btn_disabled) {
  transform: scale(1.05);
}
</style>